import { useState } from "react";
import { FiDownload } from "react-icons/fi";
import { MdExpandLess } from "react-icons/md";
import { LuLink } from "react-icons/lu";
import { IoEye } from "react-icons/io5";
import { Tooltip } from "@mui/material";
import * as S from "./style";

interface Props {
  title: string;
  pastas?: any;
  arquivos?: any;
}

const Documentos = (props: Props) => {
  const [expandedAccordion, setExpandedAccordion] = useState<string | false>(
    false
  );

  const handleChangeAccordion =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setExpandedAccordion(isExpanded ? panel : false);
    };

  function getIconAndTypeForUrl(url: string) {
    const extension = url.match(/\.\w+$/);

    if (extension) {
      switch (extension[0].toLowerCase()) {
        case ".pdf":
          return { type: "PDF" };
        case ".doc":
        case ".docx":
          return { type: "Documento" };
        case ".xls":
        case ".xlsb":
        case ".xlsm":
        case ".xltx":
        case ".xltm":
        case ".xlsx":
        case ".xml":
          return { type: "Planilha" };
        case ".png":
        case ".jpg":
        case ".jpeg":
        case ".bmp":
        case ".gif":
        case ".tiff":
          return { type: "Imagem" };
        default:
          return { icon: <LuLink />, type: "Link" };
      }
    }

    return { icon: <LuLink />, type: "Link" };
  }

  const formatUrl = (url: string) => {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      return `https://${url}`;
    }
    return url;
  };

  return (
    <S.ContentContainer>
      <S.SectionContent>
        <S.Shortcuts>
          <S.ShortcutsTitle>{props.title}</S.ShortcutsTitle>
          {props?.pastas?.[0]?.idPasta ? (
            <S.HorizontalAccordionContainer>
              {props.pastas?.map((pasta: any, index: number) => (
                <div key={pasta.idPasta}>
                  <S.Accordion
                    square
                    expanded={expandedAccordion === `panel${index}`}
                    onChange={handleChangeAccordion(`panel${index}`)}
                  >
                    <S.AccordionSummary
                      expandIcon={<MdExpandLess style={{ fontSize: "18px" }} />}
                      aria-controls={`panel${index}-content`}
                      id={`panel${index}-header`}
                    >
                      <S.Header>
                        <div>
                          <p>{pasta.nome}</p>
                        </div>
                      </S.Header>
                    </S.AccordionSummary>
                    {pasta?.arquivos ? (
                      <S.AccordionDetails>
                        <S.TableContainer>
                          <S.TableHeader>
                            <tr>
                              <th>Nome</th>
                              <th className="tipo">Tipo</th>
                              <th className="acoes">Ações</th>
                            </tr>
                          </S.TableHeader>
                          {pasta?.arquivos?.map((arquivo: any) => (
                            <S.TableBody key={arquivo.idArquivo}>
                              <S.TableCell>
                                <Tooltip
                                  title={arquivo?.nome}
                                  placement="top"
                                  followCursor
                                  arrow
                                >
                                  <td className="nome">{arquivo?.nome}</td>
                                </Tooltip>
                                <td className="tipo">
                                  {getIconAndTypeForUrl(arquivo?.url).type}
                                </td>
                                <td className="acoes">
                                  {getIconAndTypeForUrl(arquivo?.url).type !==
                                    "Link" &&
                                    arquivo?.urlVisualizacao && (
                                      <S.Button
                                        type="button"
                                        onClick={() =>
                                          window.open(
                                            formatUrl(
                                              arquivo?.urlVisualizacao ||
                                                arquivo?.url
                                            ),
                                            "_blank"
                                          )
                                        }
                                      >
                                        <IoEye size={18} />
                                      </S.Button>
                                    )}

                                  <S.Button
                                    type="button"
                                    onClick={() =>
                                      window.open(
                                        formatUrl(
                                          arquivo?.urlDownload || arquivo?.url
                                        ),
                                        "_blank"
                                      )
                                    }
                                  >
                                    {getIconAndTypeForUrl(arquivo?.url).type ===
                                    "Link" ? (
                                      <LuLink
                                        style={{
                                          fontSize: "18px",
                                          marginRight: "20px",
                                        }}
                                      />
                                    ) : (
                                      <FiDownload
                                        style={{
                                          fontSize: "18px",
                                          marginRight: "20px",
                                        }}
                                      />
                                    )}
                                  </S.Button>
                                </td>
                              </S.TableCell>
                            </S.TableBody>
                          ))}
                        </S.TableContainer>
                      </S.AccordionDetails>
                    ) : (
                      <S.NoArchieve>Não há arquivos nesta pasta</S.NoArchieve>
                    )}
                  </S.Accordion>
                </div>
              ))}
            </S.HorizontalAccordionContainer>
          ) : (
            <S.NoFolders>Não há pastas</S.NoFolders>
          )}
        </S.Shortcuts>
      </S.SectionContent>
    </S.ContentContainer>
  );
};

export default Documentos;
